import { Box, Button, Select, TextField, Typography } from '@mui/material';
import { styled, Theme } from '@mui/system';
import { MainCard } from './BaseStyles';

export const FormMainCard = styled(MainCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '100%',
  minHeight: '100dvh',
  borderRadius: 0,
  padding: '40px 24px 32px 24px',
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    padding: '96px 16px 32px 16px',
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '800px',
    minHeight: '620px',
    padding: '56px',
    borderRadius: '10px',
  },
}));

export const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  maxWidth: '450px',
  width: '100%',
  alignItems: 'center',
});

export const TitleContainer = styled(Box)(
  ({ theme, width }: { theme: Theme; width?: string }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: width || '100%',
    [theme.breakpoints.up('sm')]: {
      padding: '0 24px',
    },
  }),
);

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: theme.palette.text.primary,
  [theme.breakpoints.up('sm')]: {
    fontSize: '24px',
    lineHeight: '36px',
    textAlign: 'center',
  },
}));

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '21px',
  letterSpacing: '0.15px',
  color: theme.palette.text.secondary,
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center',
  },
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: '0 24px',
    gap: '24px',
  },
}));

export const InputDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

export const TextInput = styled(TextField)({
  width: '100%',

  '& .MuiOutlinedInput-root': {
    height: '48px',
  },
  '& .MuiInputLabel-root': {
    top: '-4px',
  },
  '& .MuiFormHelperText-root': {
    minHeight: '20px',
  },
  '& input:-webkit-autofill': {
    height: '14px',
  },
});

export const PhonePrefixSelect = styled(Select)({
  width: '150px',
  marginRight: '10px',
  height: '48px',
});

export const SubmitButton = styled(Button)({
  padding: '9px 60px',
  backgroundColor: '#0A7ABE',
  borderRadius: '100px',
  border: 'none',
  transition: 'all 0.3s ease-in-out',
  color: 'white',
  '&:hover': {
    backgroundColor: '#0A7ABE',
  },
  '&:disabled': {
    backgroundColor: '#EAEAEA',
    color: '#AFAFAF',
  },
  textTransform: 'none',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontSize: '16px',
});

export const UrlSpan = styled('span')({
  color: '#0A7ABE',
  textDecoration: 'underline',
  cursor: 'pointer',
});
